    <nav class="toolbar navbar navbar-light">
        <form class="form-inline" autocomplete="off">
            <!--<button class="btnback btn btn-outline-success"><i class="fa fa-chevron-left"></i></button>-->
            <button [disabled]="!habilitarNueva" class="btn btn-outline-success" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo </button>
            </form>
    </nav>

    <form [formGroup]="form">
        <div class="animated fadeIn container-fluid">
            <h4 style="display:inline">Seguimientos {{CodigoSolicitud}}</h4>
            <h5 style="display:inline; margin-left: 8px">
                <span>
                    <!--***ICONOS***-->
                    <!--<img class="estado-icono-big" container="body"  src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />-->
                    <!--<img class="asignada-icono" src="{{ null | IconoSolicitudAsignada}}" />-->
                    <!--<label class="codigo-icono-big" container="body" ngbTooltip="{{tituloTipoSolicitud}}">{{CodigoTipoSolicitud}}</label>-->
                    <img class="estado-icono-big" container="body" src="{{IdTipoSolicitud | IconoTipoSolicitud}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                    <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitud | IconoEstadoSolicitud}}" ngbTooltip="{{EstadoSolicitudDescripcion}}" />
                    <img *ngIf="solicitudSeguimiento?.IdEstadoChedPp" class="estado-icono-big" container="body" src="{{solicitudSeguimiento?.IdEstadoChedPp | IconoEstadoChedPP}}" ngbTooltip="{{solicitudSeguimiento?.IdEstadoChedPpDescripcion}}" />
                    <img *ngIf="solicitudSeguimiento?.IdResultadoEnvioMuestrasLaboratorio" class="estado-icono-big" container="body" src="{{solicitudSeguimiento?.IdResultadoEnvioMuestrasLaboratorio | IconoResultadoEnvioMuestraLaboratorio}}" ngbTooltip="{{solicitudSeguimiento?.DescripcionIdResultadoEnvioMuestrasLaboratorio}}" />
                    <img class="predua-icono-big" container="body" ngbTooltip="{{EsPredua | preduaNoPredua}}" src="{{EsPredua | IconoPreduaSolicitud}}" />
                    <img *ngIf="esClonada" class="estado-icono-big" container="body" src="{{ null | IconoEstadoSolicitud}}" ngbTooltip="Clonada" />
                    <i *ngIf="esClonada" class="fa fa-clone clone-icono-big" ngbTooltip="Clonada"></i>
                </span>
            </h5>

            <div class="row">
                <div class="col-md-12">

                    <ng-container *ngIf="id">
                        <app-alertarechazo [id]="id" [esImport]="true"></app-alertarechazo>
                    </ng-container>

                    <div class="card card-accent-success">

                        <div class="card-header-buscador">
                            <i class="fa fa-align-justify"></i> Listado de Seguimientos
                        </div>

                        <div class="card-body-grid">

                            <p-table #tableSearchObservaciones autoLayout="true" [value]="TComentarioInspectorCollection"
                                     [columns]="colsObservaciones" sortField="Fecha" sortOrder="-1"
                                     styleClass="table table-responsive-sm table-striped table-sm"
                                     [ngClass]="displayGridHidden(TComentarioInspectorCollection)">

                                <ng-template pTemplate="header" let-columns>
                                    <tr>
                                        <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                            {{col.header}}
                                            <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                        </th>
                                    </tr>
                                </ng-template>
                                <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                    <tr>

                                        <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                            <span *ngIf="(col.field!=='Link' && col.field!=='Fecha')">{{rowData[col.field]}}</span>
                                            <span *ngIf="col.field==='Fecha'">{{rowData[col.field] | date:'dd/MM/yyyy HH:mm:ss'}}</span>
                                            <div *ngIf="col.field==='Link'" class="btn-group">
                                                <div *ngIf="checkEdit(rowData)">
                                                    <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                            class="btn btn-sm btn-warning">
                                                        <span class="fa fa-edit"></span>

                                                    </button>
                                                </div>

                                                <div *ngIf="!checkEdit(rowData)">
                                                    <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                            class="btn btn-sm btn-info">
                                                        <span class="fa fa-search"></span>

                                                    </button>
                                                </div>

                                                <div *ngIf="checkDelete(rowData)">
                                                    <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                            class="btn btn-sm btn-danger">
                                                        <span class="fa fa-remove"></span>

                                                    </button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>

                                </ng-template>
                            </p-table>
                            <div *ngIf="TComentarioInspectorCollection?.length == 0" class="empty-grid">
                                No hay seguimientos asociados a la solicitud
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </form>
